import { SystemAndComponentTooltip } from './system-and-component-tooltip';
import { SystemAndComponentPartNameProps } from '../types';
import { useBreakpoint } from '@cat-ecom/pcc-components/src/hooks';
import { PAGE_BREAKPOINTS } from '@cat-ecom/pcc-components/src/constants/commonConstants';
import { SystemAndComponentNameDescription } from './system-and-component-name-description';

export const SystemAndComponentPartName = ({
  partsName,
  handleClick,
  classname
}: SystemAndComponentPartNameProps) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  return (
    <div className={classname}>
      {isMD ? (
        <SystemAndComponentTooltip
          position="auto"
          partsName={partsName}
          className="d-flex"
          handleClick={handleClick}
        >
          {partsName}
        </SystemAndComponentTooltip>
      ) : (
        <SystemAndComponentNameDescription
          partsName={partsName}
          handleClick={handleClick}
        />
      )}
    </div>
  );
};
